var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2404_1263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1713 13.3543V21.5995L16.0003 26.8934L6.82415 21.5995V11.0066L16.0003 5.70755L23.0486 9.77899L24.1124 9.16522L16.0003 4.47998L5.76025 10.3928V22.2133L16.0003 28.1261L26.2403 22.2133V12.7405L25.1713 13.3543Z",
    fill: "url(#paint0_linear_2404_1263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4324 21.6044H11.8979V16.4589H17.0128C17.4967 16.4535 17.9591 16.2578 18.2999 15.9142C18.6407 15.5706 18.8324 15.1066 18.8338 14.6226C18.8365 14.3833 18.7903 14.146 18.698 13.9252C18.6056 13.7044 18.469 13.5049 18.2967 13.3388C18.1299 13.1674 17.9302 13.0315 17.7096 12.9392C17.489 12.8469 17.252 12.8002 17.0128 12.8018H11.8979V11.2366H17.018C17.9143 11.2419 18.7725 11.6004 19.4063 12.2343C20.0402 12.8681 20.3986 13.7262 20.404 14.6226C20.4095 15.3088 20.2002 15.9794 19.8056 16.5407C19.4423 17.0777 18.9304 17.4972 18.3325 17.7479C17.7404 17.9356 17.1225 18.0288 16.5013 18.024H13.4324V21.6044Z",
    fill: "url(#paint1_linear_2404_1263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3685 21.4767H18.5783L17.1973 19.0676C17.7436 19.0342 18.2826 18.924 18.7982 18.7402L20.3685 21.4767Z",
    fill: "url(#paint2_linear_2404_1263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1021 11.6409L25.1609 12.2291L26.2196 11.6409V10.3979L25.1609 9.78418L24.1021 10.3979V11.6409Z",
    fill: "url(#paint3_linear_2404_1263)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2404_1263",
    x1: 26.2221,
    y1: 10.3993,
    x2: 4.50772,
    y2: 19.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2404_1263",
    x1: 26.222,
    y1: 10.3991,
    x2: 4.50755,
    y2: 19.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2404_1263",
    x1: 26.2223,
    y1: 10.3992,
    x2: 4.50787,
    y2: 19.0828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2404_1263",
    x1: 26.222,
    y1: 10.3993,
    x2: 4.50758,
    y2: 19.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2404_1263"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.2002,
    y: 3.19995,
    width: 25.6,
    height: 25.6,
    rx: 12.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRay);
export default __webpack_public_path__ + "static/media/RAY.499070df9e56328778f8e285009beec2.svg";
export { ForwardRef as ReactComponent };